export default __webpack_public_path__ + "static/media/InvestmentCase-02.505c2740.jpg";